export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fCRc4EsA.woff2";